<template>
  <div class="hot-ranking">
    <div class="row hot-ranking-item" v-for="(item, index) in data" :key="index">
      <div class="row">
        <div class="hot-ranking-item-index" :class="{'hot-ranking-item-top-index': index===0 || index===1 || index===2}">{{index+1}}</div>
        <div>
          <router-link class="hot-ranking-item-title" target="_blank" :to="{path: '/result', query:{q: item.company}}">
            <div>{{item.stock_code}}</div>
          </router-link>
          <router-link class="hot-ranking-item-content-a" target="_blank" :to="{path: '/event-detail', query:{title: item.title, id: item.event_id}}">
            <div class="hot-ranking-item-content" :style="{width: `${width}px`}">{{item.title}}</div>
          </router-link>
        </div>
      </div>
      <div class="hot-ranking-item-count" :class="{'hot-ranking-item-count-positive': item.sentiment==='正面' || sentiment==='正面', 'hot-ranking-item-count-negative': item.sentiment==='负面' || sentiment==='负面'}">{{item.heat}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    sentiment: {
      type: String
    },
    width: {
      type: Number
    }
  },
  methods: {
    toEventDetailPage(id, title) {
      const routeUrl = this.$router.resolve({
        path: '/event-detail', 
        query: {
          title,
          id
        }  
      });
      window.open(routeUrl.href, '_blank');
    },
    toCompanyDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/result', 
        query: {
          q: res
        }  
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.hot-ranking {
  padding: 6px 24px;
  &-item {
    padding: 10px 0;
    justify-content: space-between;
    &-index {
      width: 25px;
      height: 100%;
      color: #747990;
      font-size: 14px;
    }
    &-top-index {
      color: #ff5b65;
    }
    &-title {
      margin-bottom: 4px;
      color: #171f46;
      font-size: 14px;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
    &-content-a {
      text-decoration: none;
    }
    &-content {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #747990;
      font-size: 12px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    &-count {
      width: 45px;
      text-align: center;
      color: #464d6c;
      font-size: 14px;
    }
    &-count-positive {
      color: #ff5b65;
    }
    &-count-negative {
      color: #36c292;
    }
    &-count::after {
      content: "\00b0";
    }
  }
}
</style>
